module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page3"
  }, [_c('div', {
    staticClass: "jobPrivi-privilege"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "job-comment"
  }, [_c('div', {
    staticClass: "job-swiper-pagination"
  }, [_c('div', {
    staticClass: "jobPrivi-icon"
  }, [_c('ul', _vm._l((_vm.commentData), function(item, index) {
    return _c('li', {
      staticClass: "icon-page hover-class",
      on: {
        "mouseenter": function($event) {
          return _vm.enter(index)
        },
        "mouseleave": function($event) {
          return _vm.leave()
        },
        "click": function($event) {
          return _vm.show(item.clickShow, item.actionType)
        }
      }
    }, [_c('div', {
      staticClass: "icon-radius"
    }, [_c('div', {
      staticClass: "icon-box",
      class: {
        'active': index === _vm.currentIndex
      }
    }, [_c('div', {
      staticClass: "icon",
      style: ({
        backgroundImage: 'url(' + item.iconUrl + ')',
        backgroundSize: 'contain'
      })
    })])]), _vm._v(" "), _c('p', {
      staticClass: "detail-text"
    }, [_vm._v("查看详情")]), _vm._v(" "), _c('div', {
      staticClass: "icon-title"
    }, [_vm._v(_vm._s(item.privTitle))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "comment-display"
  }, [_vm._l((_vm.commentData), function(item, index) {
    var _obj;

    return (index === _vm.currentIndex) ? _c('div', {
      key: index,
      staticClass: "comment-box",
      class: ( _obj = {
        'dialog-box-active': index === _vm.currentIndex
      }, _obj[item.itemClass] = index === _vm.currentIndex, _obj )
    }, [_c('div', {
      staticClass: "comment"
    }, [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "dialog-box"
    }, [_c('p', {
      staticClass: "comment-text"
    }, [_c('span', {
      staticClass: "mark-max"
    }, [_vm._v(" “")]), _vm._v(" "), _c('span', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(item.comments[_vm.randomIndex].commentText)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "priv-result"
    }, [_vm._v("\n                                " + _vm._s(item.comments[_vm.randomIndex].privResult)), _c('span', {
      staticClass: "result"
    }, [_vm._v(_vm._s(item.comments[_vm.randomIndex].result))])]), _vm._v(" "), _c('p', {
      staticClass: "comment-from"
    }, [_vm._v(_vm._s(item.comments[_vm.randomIndex].commentFrom))])])])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-bg"
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "btn-buyvip"
  }, [_c('p', {
    staticClass: "btn-text",
    on: {
      "click": function($event) {
        return _vm.buyVipDialog('pc-cvip-huiyuantequan-xiangshouqiuzhitequan')
      }
    }
  }, [_vm._v("开启求职快车道")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "priv-title"
  }, [_vm._v("求职特权")]), _vm._v(" "), _c('div', {
    staticClass: "priv-desc"
  }, [_vm._v("多项求职特权免费使用，面试几率提升300%")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "arrow"
  }, [_c('div', {
    staticClass: "hidden-line"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51d14ed6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/modules/privileges/JobPrivilege.vue
// module id = 7xeD
// module chunks = 1